import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    const $subNavLink = $('.header-nav__sticky-header-menu .sub-nav__item:first-child .sub-nav__link');
    $subNavLink.on('click', (e) => {
        e.preventDefault();
    });
});
